module.exports = __webpack_public_path__ + "images/branding/loan_review/logged_out.gif";